module.exports = __webpack_public_path__ + "static/blog-post--img-7-8e8540e13f57844a828681f4433062e8.jpg";